<template>
  <div>
    <b-card  title="Tour Overview"> 
     <TourTableRiver />
    </b-card>
       
  </div>
</template>


<script>
import TourTableRiver from './TourTableRiver.vue';

export default {
  components: {
    TourTableRiver,
  },
};
</script>



